<template>
    <div class="choose-fee-full">
        <div class="content">
            <mobile-card>
                <template slot="title">
                    <span>{{selectItem.itemName}}</span>
                </template>
                <template slot="content">
                    <div class="flex-form-info" v-if="selectIntervalName">
                        <span>交费区间</span>
                        <span @click="selectRange">{{model.rangeName}}
                        <van-icon name="arrow-down"/>
                        </span>
                    </div>
                    <div class="border-bottom-solid" v-if="selectIntervalName"/>
                    <div class="flex-form-info" v-if="selectMoney">
                        <span>单价</span>
                        <span @click="selectPrice">{{model.priceName}}
                        <van-icon name="arrow-down"/>
                        </span>
                    </div>

                    <div class="flex-form-info" v-else-if="editMoney">
                        <span>金额</span>
                        <span class="input-border">
                        <van-field
                            ref="moneyRef"
                            v-model="model.money"
                            style="padding: 0px;width: 150px"
                            clearable
                            autofocus
                            right-icon="edit"
                            @click-right-icon="$refs.moneyRef.focus()"
                            placeholder="请填入交费金额"
                            type="number"
                            input-align="right"
                        ></van-field>
                    </span>
                    </div>
                    
                    <div class="flex-form-info" v-else>
                        <span>金额</span>
                        <span class="money-item">{{model.money | formatMoney}}</span>
                    </div>
                    <div class="border-bottom-solid" />
                    <div class="flex-form-info" v-if="editCount">
                        <span style="line-height:30px;">数量</span>
                        <van-stepper v-model="model.count"/>
                    </div>
                    <div class="border-bottom-solid" v-if="editCount" />
                    <div class="flex-form-info">
                        <span>备注：</span>
                    </div>
                    <div class="flex-form-info" style="width:100%;">
                        <van-form style="width:100%;">
                        <van-field input-align="left" label-align="right" size="14px" class="remark-style"
                            v-model="model.remark"
                            name="remark"
                            rows="5"
                            style="padding: 0px; margin: 0px; padding-right: 5px; text-align:right;font-size:13px;"
                            autosize
                            type="textarea"
                            :placeholder="selectItem.itemRemark"
                            :rules="[{validator: validateLength, message: '备注最大长度500（最多可输入250个汉字)',trigger:'onChange'}]"
                            @input="handleWordsCount"
                            
                        />
                        <div class="remarkWordsCount">
							<span :class="{'current_count': true,
							'err_count': errItem.isError}"
							>{{wordsCount}}</span>
							<span class="seperator">/</span>
							<span class="total_count">{{ Math.floor(500 / 2) }}</span>
                        </div>
                        </van-form>
                    </div>
                    <div class="border-bottom-solid" />
                </template>
            </mobile-card>
        </div>
        <div class="footer">
            <choose-fee-footer :model="model" @commit="onCommit"></choose-fee-footer>
        </div>

        <van-popup v-model="showRangePicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="intervalArray"
                    :default-index="defaultIndex"
                    @cancel="showRangePicker = false"
                    @confirm="onConfirm"
            ></van-picker>
        </van-popup>
        <van-popup v-model="showPricePicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="priceArray"
                    :default-index="defaultIndex"
                    @cancel="showPricePicker = false"
                    @confirm="onConfirm2"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
    import util from '@/utils/util'
    import storage from 'good-storage'
    import MobileCard from "components/mobile-card/index"
    import ChooseFeeFooter from './choose-fee-footer/index'
    import apiChooseFee from "api/choose-fee";

    export default {
        components: {ChooseFeeFooter, MobileCard},
        data() {
            const validateLength = (value) => {
				if (value) {
					// 当输入了值时才验证
					if (util.getStrLength(value) > 500) {	
                        this.errItem.isError = true
                        return false
					} else {
                        this.errItem.isError = false
						return true
					}
				} else {
                    this.errItem.isError = false
					return true
				}
			};
            return {
                selectItem: {},
                showRangePicker: false,
                showPricePicker: false,
                code:'',
                defaultIndex: 0,
                model: {
                    rangeName: '',
                    range: null,
                    priceName:'',
                    money: 0,
                    count: 1,
                    remark: "",
                    enableUseCompanyTitle: true,
                },
                validateLength,
                wordsCount:0,
                errItem:{
                    isError:false,
                }
            }
        },
        computed: {
            selectIntervalName() {
                // 判断是不是多区间
                let r = Array.isArray(this.selectItem.intervals) && this.selectItem.intervals.length > 1
                return r
            },
            selectMoney() {
                // let r =
                //     Array.isArray(this.selectItem.moneys) && this.selectItem.moneys.length > 1
                // return r
                return this.selectItem.feeMode===2
            },
            editMoney() {
                //return this.selectItem.editMoney
                return this.selectItem.feeMode===3
            },
            intervalName() {
                if (Array.isArray(this.selectItem.intervals)) {
                    return this.selectItem.intervals[0].intervalName
                } else {
                    return '--'
                }
            },
            priceName(){
                if (Array.isArray(this.selectItem.moneys)) {
                    return this.selectItem.moneys[0].name
                } else {
                    return '--'
                }
            },
            editCount(){
                return this.selectItem.canChangeCount
            },
            intervalArray() {
                if (this.selectIntervalName) {
                    return this.selectItem.intervals.map(x => x.intervalName)
                } else {
                    return []
                }
            },
            priceArray(){
                if(this.selectMoney){
                    return this.selectItem.moneys.map(x => x.name)
                }else{
                    return []
                }
            },
            sumMoney() {
                let {money, count} = this.model
                money = Number(money)
                count = Number(count)
                return money * count
            }
        },
        methods: {
            getItem(){
                apiChooseFee.detail({code:this.code}).then(res=>{
                    if (res.data) {
                        this.selectItem = res.data;
                        this.setModel();
                    }
                })
            },
            onConfirm(value, index) {
                // log('value', value, index)
                let v = this.selectItem.intervals
                let item = v[index]
                this.defaultIndex = index
                this.model.range = item.intervalId
                this.model.rangeName = item.intervalName
                this.showRangePicker = false
            },
            onConfirm2(value, index) {
                let v = this.selectItem.moneys
                let item = v[index]
                this.defaultIndex = index
                this.model.money = item.money
                this.model.priceName = item.name
                this.showPricePicker = false
            },
            // onCancel() {
            //     this.showRangePicker = false
            // },
            setModel() {
                this.model.rangeName = this.intervalName
                this.model.priceName = this.priceName

                if (this.selectItem.intervals) {
                    this.model.range = this.selectItem.intervals[0].intervalId
                } else {
                    this.model.range = {
                        name: null,
                        id: null
                    }
                }

                if (this.selectItem.moneys) {
                    this.model.money = this.selectItem.moneys[0].money
                } else {
                    this.model.money = 0
                }
                this.model.enableUseCompanyTitle = this.selectItem.enableUseCompanyTitle
            },
            selectRange() {
                this.showRangePicker = true
            },
            selectPrice(){
                this.showPricePicker = true
            },
            onCommit() {
                let enableUseCompanyTitle = this.model.enableUseCompanyTitle?true:false;
                let item = {
                    intervalId: this.model.range,
                    itemCount: this.model.count,
                    itemId: this.selectItem.itemId,
                    itemName: this.selectItem.itemName,
                    intervalName: this.model.rangeName,
                    itemMoney: Number(this.model.money),
                    nowMoney:this.sumMoney,
                    itemRemark: this.model.remark,
                    ticketTypeId: this.selectItem.ticketTypeId
                }
                let param = {
                    allMoney: this.sumMoney,
                    chooseFee: item,
                    pendFees:[item],
                    enableUseCompanyTitle: enableUseCompanyTitle
                }
                apiChooseFee.check(param).then(res => {
                    if (res.data) {
                        let obj = {
                            name: "pay-confirm",
                            query: {
                                type: 2,
                                enableUseCompanyTitle
                            },
                        }
                        //setState('pay-ticket', res.data)
                        storage.session.set('pay-ticket', res.data)
                        this.$router.push(obj)
                    }
                })
            },
            handleWordsCount(){
                let textareaval = this.model.remark;
                this.wordsCount = util.getWordsCount(textareaval)
            }
        },
        created() {
            this.code = this.$route.query.code
            this.getItem();
            //console.log(this.model.money)
        },
        mounted() {
        },
        activated() {
            this.getItem();
            // let select = getState('select-item')
            // if (select) {
            //     this.selectItem = select
            //     this.setModel()
            // } else {
            //     this.$router.push({
            //         name: 'home',
            //     })
            // }
        }
    }
</script>

<style lang='scss' scoped>
    /*.flex-form-info {*/
    /*    padding: 5px;*/
    /*    display: flex;*/
    /*    justify-content: space-between;*/
    /*}*/

    /*.money-item {*/
    /*    color: #3b7a53;*/
    /*}*/

    .input-border {
        /deep/ .van-field__body {
            //border: 1px solid #005423;
            border-radius: 5px;
        }

        /deep/ .van-cell {
            padding: 0px;
        }
    }

    .choose-fee-full {
        height: 100%;
        width: 100%;

        .content {
            height: 92%;
            overflow-y: auto;
            overflow-x: hidden;
        }

        .footer {
            max-height: 100px;
            height: 8%;
        }
    }

    .border-bottom-solid {
        border-bottom: 1px solid #d3d3d3;
        margin-left: 10px;
        margin-right: 10px;
    }
    .van-cell::after{
        content:' ';
        border:none;
    }

    .flex-form-info {
        position: relative;
        .remarkWordsCount {
            position: absolute;
            right: 11px;
            bottom: 3px;
            color: #909399;
            font-size: 12px;
            height: 16px;
            line-height: 16px;
            border: none;
        }
        .current_count {
            font-size: 16px;
            /* color: gainsboro; */
            color: #67c23a;
            font-weight: 600;
            font-style: italic;
        }
        .err_count {
            color: red;
        }
        .remark-style {
			& ::placeholder{
				color:#333;
			}
		}
    }

</style>
